import React from 'react';
import styles from './index.less';
import dfLogo from './df.svg';
import { classNames } from '../utils';

export function LoadingInPage() {
  return (
    <div className={classNames(styles.container, styles.container_in_page)}>
      <span className={styles.circle_1}></span>
      <span className={styles.circle_2}></span>
    </div>
  );
}
export function LoadingWithLogo(props: {logo?: string}) {
  return (
    <div className={classNames(styles.container, styles.container_with_logo)}>
      <img className={styles.logo} src={props.logo || dfLogo}  alt=""/>
      <span className={styles.circle_1}></span>
      <span className={styles.circle_2}></span>
    </div>
  );
}

function Index() {
  return (
    <div className={styles.container}>
      <span className={styles.circle_1}></span>
      <span className={styles.circle_2}></span>
    </div>
  );
}

export default Index;
